export default __webpack_public_path__ + "static/media/dewhurst-logo.6e6c48c2.png";